import { render, staticRenderFns } from "./TabInfo.vue?vue&type=template&id=0fca3c92&"
import script from "./TabInfo.vue?vue&type=script&lang=js&"
export * from "./TabInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports